import $ from "jquery";
import _ from "underscore";
import Backbone from "backbone";
import React from "react";
import { createRoot } from "react-dom/client";
import pageTemplate from "text!../../../templates/mylibrary/assetsPageTemplate.html";
import AssetsLibraryPage from "../../components/library/AssetsLibraryPage";
import ti18n from "i18n!nls/MyLibraryi18n";

const AssetsPageView = Backbone.View.extend({
  template: _.template(pageTemplate),

  pageName: "Assets",

  events: {
    "click #homeHeaderButton": "onHomeButtonSelected",
    "click #pageActionButton": "onImportAssetsSelected",
  },

  initialize: function () {
    this._reactRoot = null;
  },

  onHomeButtonSelected: function () {
    this.trigger("showHomePopup");
  },

  onImportAssetsSelected: function () {
    this.trigger("importAssets");
  },

  _onPageShow: function () {
    this.trigger("pageshow");
  },

  _onPageHide: function () {
    this.trigger("pagehide");
  },

  _onPageRemoved: function () {
    if (this._reactRoot) {
      this._reactRoot.unmount();
      this._reactRoot = null;
    }
    this.undelegateEvents();
    this.$el.removeData().unbind();
    this.stopListening();
  },

  _renderLibraryPage: function () {
    const reactContainer = this.$el.find("#libraryReactRoot").get(0);
    if (!reactContainer) return;

    if (!this._reactRoot) {
      this._reactRoot = createRoot(reactContainer);
    }

    this._reactRoot.render(
      React.createElement(AssetsLibraryPage)
    );
  },

  render: function () {
    this.$el.html(this.template({ ti18n: ti18n }));
    this.setElement(this.$el.find("div").first());
    this.$el.page();

    this._renderLibraryPage();

    this.$el
      .children(
        ".ui-header:not(.ui-header-fixed), .ui-content:not(.ui-popup), .ui-footer:not(.ui-footer-fixed)"
      )
      .wrapAll("<div class='ui-panel-wrapper'></div>");

    this.$el.on("pageshow", this._onPageShow.bind(this));
    this.$el.on("pagehide", this._onPageHide.bind(this));
    this.$el.on("remove", this._onPageRemoved.bind(this));

    return this;
  },
});

export default AssetsPageView;
